import React, { Component } from "react";
import "../App.css";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import { gsap, Power1 } from "gsap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import Layout from "../components/layout/layout";
import Leistung from "../components/leistung";
import TextZwei from "../components/textZwei";
import InfoText from "../components/infoText"
import LeistungHero from "../components/leistungHero"
import Testimonial from "../components/testimonial"

//Data
import Sanitaer from "../images/Icon Sanitär.png";
import Heizungsbau from "../images/Icon Heizungsbau.png";
import Energien from "../images/Icon Erneuerbare Energien.png";
import Background from "../images/Badkonzepte_2.jpg"

import BadImage1 from "../images/EV7A2177-122.webp";
import BadImage2 from "../images/EV7A2155-100.webp";
import BadImage3 from "../images/heller_EV7A2160-105.webp";

import BadImageVertical1 from "../images/20250225_090947.webp";
import BadImageVertical2 from "../images/20250225_091951.webp";
import BadImageVertical3 from "../images/20250225_092149.webp";
import BadImageVertical4 from "../images/EV7A2156-101.webp";
import BadImageVertical5 from "../images/IMG_20250225_092435.webp";
import BadImageVertical6 from "../images/retusch_IMG_20250225_091639.webp";





import leistung from "../data/leistungen.json";
import data from "../data/badkonzepte.json";

const TextContainer = styled.div`
  padding: 100px 0px 20px 0px;
  text-align: center;
`;

const LeistungContainer = styled.div`
  width: 90vw;
  max-width: 1400px;
  margin: 0px auto 150px auto;
  padding: 10px;

`;

const SliderContainer = styled.div`
  width: 90vw;
  max-width: 1400px;
  margin: 50px auto 150px auto;
  
  .slick-slide {
    padding: 0 10px;
  }

  .slick-slide img {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
  }
  
  .slick-prev, .slick-next {
    z-index: 1;
    &:before {
      color: #666666;
    }
  }
  
  .slick-prev {
    left: 25px;
  }
  
  .slick-next {
    right: 25px;
  }
`;

class FlaschnereiLeistungen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    let container = document.querySelector(".content_container");

    let tl = gsap.timeline();
    tl.to(container, { duration: 0, opacity: 0, y: 30 })
      .to(container, {
        duration: 0.8,
        opacity: 1,
        y: 0,        
        ease: Power1.easeOut,
      })
}
  render() {
    const sliderSettingsVertical = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true
    };

    const sliderSettingsHorizontal = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      pauseOnHover: true
    }

    return (
      <Layout pageTitle="Badkonzepte" description="Wasser in seiner reinsten Form zu erleben ist wahrer Genuss. Aus Ideen werden bei Hengel Wirklichkeit. Ein schönes und funktionales Bad braucht eine fundierte Vorplanung.">
      <LeistungHero heading={data.heading} text={data.intro} imageUrl={`url("${Background}")`}/>
      <InfoText heading="Vertrauen Sie dem Experten" list={data.details.list}/>
      <SliderContainer>
          <Slider {...sliderSettingsVertical}>
            <div>
              <img src={BadImageVertical1} alt="Badezimmer Design 1" />
            </div>
            <div>
              <img src={BadImageVertical2} alt="Badezimmer Design 2" />
            </div>
            <div>
              <img src={BadImageVertical3} alt="Badezimmer Design 3" />
            </div>
            <div>
              <img src={BadImageVertical4} alt="Badezimmer Design 4" />
            </div>
            <div>
              <img src={BadImageVertical5} alt="Badezimmer Design 5" />
            </div>
            <div>
              <img src={BadImageVertical6} alt="Badezimmer Design 6" />
            </div>  
          </Slider>
        </SliderContainer>
        <TextZwei heading={data.info.heading} text={data.info.text} />
        <SliderContainer>
          <Slider {...sliderSettingsHorizontal}>
            <div>
              <img src={BadImage1} alt="Badezimmer Design 7" />
            </div>
            <div>
              <img src={BadImage2} alt="Badezimmer Design 8" />
            </div>
            <div>
              <img src={BadImage3} alt="Badezimmer Design 9" />
            </div>
          </Slider>
        </SliderContainer>
        <Testimonial heading={data.kundenstimme.heading} text={data.kundenstimme.text} />
        <hr/>
        <TextContainer>
          <h4>Wir bieten auch</h4>
        </TextContainer>
        <LeistungContainer>
          <Grid container spacing={8}>
            {leistung.Leistungen.filter(function (item) {
              if (item.heading === "Badkonzepte") {
                return false;
              }
              return true;
            }).map((item) => (
              <Grid item md={4}>
                <Leistung
                  icon={
                    item.heading === "Sanitär"
                      ? Sanitaer
                      : item.heading === "Heizungsbau"
                      ? Heizungsbau
                      : item.heading === "Erneuerbare Energien"
                      && Energien
                  }
                  header={item.heading}
                  slug={item.slug}
                  text={item.text}
                />
              </Grid>
            ))}
          </Grid>
        </LeistungContainer>
      </Layout>
    );
  }
}

export default FlaschnereiLeistungen;
